// extracted by mini-css-extract-plugin
module.exports = {"major":"money_major__5zSTg","minor":"money_minor__QdNqx","symbol":"money_symbol__ynvCl"};